export const BATHTUBE_STEPS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Nine'];

export const BATHTUBE_STEPS_NO_FLANGES = ['One', false, 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Nine'];

export const DWDF_STEPS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six'];

export const DWDF_STEPS_NO_APRON = ['One', 'Two', 'Three', false,'Five', 'Six'];

export const KRW_STEPS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Seven'];


// WEBPACK FOOTER //
// ./src/constants/steps.js